export { default as UserTypeStep } from './UserTypeStep';
export { default as OtpStep } from './OtpStep';
export { default as UserDetailsStep } from './UserDetailsStep';
export { default as WorkDetailsStep } from './WorkDetailsStep';
export { default as EmailVerificationStep } from './EmailVerificationStep';
export { default as UpdateEmailStep } from './UpdateEmailStep';
export { default as UpdatePhoneStep } from './UpdatePhoneStep';
export type {
  RegisterStep,
  UserType,
  RegisterStepProps,
  RegisterFormValues,
  RegisterModalProps,
  ApiError,
} from '@src/v3/interfaces/components/registerModal';
export {
  phoneValidationSchema,
  otpValidationSchema,
  userTypeValidationSchema,
  userDetailsValidationSchema,
  initialValues,
} from '@src/v3/schemas/components/register/index';
